export const formatDateTime = (date: Date): string => {
  const pad = (num: number): string => String(num).padStart(2, '0')
  
  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export const parseDateTime = (dateStr: string): Date => {
  return new Date(dateStr.replace(' ', 'T'))
} 